angular.module("app").controller("FiltersEditPageController", [
    '$scope',
    '$filter',
    'preloadedData',
    'casinoCategoryService',
    'errorHandler',
    'logger',
    'pageStatuses',
    'deepCompare',
    '$uibModalInstance',
    'settingsService',
    'casinoGameService',
    function ($scope, $filter, preloadedData, casinoCategoryService, errorHandler, logger, pageStatuses, deepCompare, $modalInstance, settingsService, casinoGameService) {

        $scope.tooltip = {
            name: "",
            title: ""
        };

        $scope.skins = [];

        var translator = $filter('translate'),
            settings = settingsService.getSettings();

        var tmpLanguages = [], addElementHelper;

        angular.forEach(settings.languages, function (lang) {
            if (lang == 'en') return true;

            tmpLanguages.push({
                id: lang,
                title: lang.toUpperCase() + ' - ' + translator('top_menu.languages.' + lang),
                placeholder: 'Name'
            });
        });

        $scope.languages = tmpLanguages;

        $scope.pageStatuses = pageStatuses;

        $scope.save = function () {
           addElementHelper = $scope.useAddElementHelper();

            if (!$scope.edit_category_form.$valid) {
                return;
            }else if ($scope.isAllowedToUpdate()){
                logger.logError("global.no_changes");
                return;
            }
            var requestData = {
                    casinoCategory: {}
                },
                changes;
            var fetchedData = fetchData();
            changes = deepCompare.getChanges(preloadedData.category, fetchedData);
            changes.id = preloadedData.category.id;

            if (fetchedData.skins) {
                changes.skins = fetchedData.skins
            }

            requestData.casinoCategory = changes;
            if (fetchedData.translations) {
                requestData.casinoCategory =  requestData.casinoCategory || {};
                requestData.casinoCategory.id = preloadedData.category.id;
                requestData.casinoCategory.translations = fetchedData.translations;
            }

            casinoCategoryService.edit(requestData).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("updated");
                        preloadedData.category = fetchData();
                        $modalInstance.close();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.isAllowedToUpdate = function () {
            return deepCompare.isEqual(fetchData(), preloadedData.category)
        };

        function init () {
            var category = preloadedData.category;
            $scope.filterData = angular.copy(category);
            if (category.translations !== undefined && category.translations.title !== undefined) {
                $scope.categoryTitleTranslation = angular.copy(category.translations.title);
            }
            $scope.edit_category_form && $scope.edit_category_form.$setPristine();

            if (category.is_custom) {
                casinoGameService.getSkins().then(
                    function (response) {
                        if (response.status == "ok") {
                            $scope.skins = angular.copy(response.skins).map(function (item) {
                                item.name = "ID:" + item.id + " " + item.name;
                                return item
                            });
                        }
                    }
                )
            }
        }

        function fetchData () {
            if ($scope.filterData.type === 'category') {
                $scope.filterData.translations = addElementHelper.fetchData('categoryTitleTranslation');
            }
            return angular.copy($scope.filterData);
        }

        init();

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
]);
